import React from "react";
import CoordsInput from "./CoordsInput";
import Grid from "./Grid";
import type { StrCoords } from "../tableReducer";
import { convert } from "../api";
import type { ICoords, SrsPair, ISRS } from "../types";

interface CoordsRowProps {
  coords: StrCoords;
  srsPair: SrsPair;
  srs: ISRS;
  onChange: (coords: StrCoords) => void;
};

const CoordsRow = (props: CoordsRowProps) => (
  <Grid
    left={<CoordsInput coords={props.coords} onChange={props.onChange} />}
    right={
      <CoordsInput
        coords={convertStringCoords(props.srsPair, props.srs, props.coords)}
        onChange={() => undefined}
      />
    }
  />
);
export default CoordsRow;

function convertStringCoords(
  srsPair: SrsPair,
  srs: ISRS,
  coords: StrCoords,
): StrCoords {
  if (!coords.x || !coords.y || !coords.z) {
    return { x: "", y: "", z: "" };
  }
  const numericCoords = coordsToNumber(coords);
  const convertedCoords = convert(srsPair, srs, numericCoords);
  return coordsToString(convertedCoords);
}

function coordsToNumber(coords: StrCoords): ICoords {
  return Object.keys(coords).reduce(
    (acc, curr: keyof StrCoords) => ({
      ...acc,
      [curr]: parseFloat(coords[curr]),
    }),
    {} as ICoords,
  );
}

function coordsToString(coords: ICoords): StrCoords {
  // eslint happy
  return {
    x: `${coords.x}`,
    y: `${coords.y}`,
    z: `${coords.z}`,
  };
}
